export const clientLifecycleLabels = ["Active client", "Inactive client", "Client"];

export const read_client_lifecycle_label = (value) => {
    const text = `${value || ""}`.trim();
    if (text.toLowerCase() === "past client") return "Inactive client";
    return clientLifecycleLabels.find(label => label.toLowerCase() === text.toLowerCase()) || text;
};

export const read_client_label_after_sales_update = (row, salesStatus) => {
    const activity = row?.clientActivity || row?.brandRecord?.clientActivity;
    if (activity?.member === true) {
        return ({ active: "Active client", inactive: "Inactive client", unknown: "Client" })[activity.state] || "Client";
    }
    if (activity?.member === false) return salesStatus;
    const label = read_client_lifecycle_label(row?.lastStatus || row?.brandRecord?.lastStatus);
    // A saved label has no current subscription evidence. Preserve membership
    // visibility while waiting for the authoritative computed activity response.
    return clientLifecycleLabels.includes(label) || row?.client === true || row?.brandRecord?.client === true ? "Client" : salesStatus;
};
